import React from 'react';
import { faPlus, faMinus } from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const CategoryContainer = ({
  selected,
  category,
  cat,
  handleSelected,
  setCategory
}) => {
  return (
    <div className="faq-general-container">
      <div className="category-name">{cat.type}</div>
      <FontAwesomeIcon
        icon={
          selected.some(a => a === cat.type) && category === cat.type
            ? faMinus
            : faPlus
        }
        // size={window.innerWidth > 768 ? '2x' : '1x'}
        className="plus-icon"
        onClick={() => {
          handleSelected(cat.type);
          setCategory(cat.type);
        }}
      />
    </div>
  );
};

export default CategoryContainer;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/CategoryContainer.js